module.exports = __webpack_public_path__ + "static/media/product2.56c10780.jpg";